import { render } from "./GreekReferences.vue?vue&type=template&id=23d93bf4"
import script from "./GreekReferences.vue?vue&type=script&lang=js"
export * from "./GreekReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__